module.exports = __webpack_public_path__ + "img/CM-AB-24-INFINITI-Lifestyle-v1.3f1a3489.jpg";